import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import util from '../common/util';
import { unformats } from '../common/format';
import { LOGIN, UPDATE_SOCIAL_TAG_TYPE } from '../store/mutation-types';
import questionnaire from '../components/questionnaire';
import vForm from '../components/v-form.vue';
import vInput from '../components/v-input.vue';
import { state as regState } from '@/components/sign-log/register-track';
import AutoRegister from '../common/autoRegister';
import { openLoginHideOtherPop } from '../common/autopopup';

import { loginOrRegister } from '@/components/sign-log/socialstudio-lead-tag.js';
export default {
    data() {
        return {
            registerErrorShow: false,
            registerErrorMsg: '',
            data: {}
        };
    },
    mounted() {
        this.autoRegisterInstance = AutoRegister.getInstance(
            this,
            this.hasEmailLead
        );
        this.autoRegisterInstance.start();
    },
    beforeDestroy() {
        this.autoRegisterInstance.destroy();
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            page: state => state.page.page
        }),
        ...mapGetters('page', ['hasEmailLead']),
        ignoreBuyerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreBuyerPhone);
        },
        ignoreSellerPhone({ page }) {
            return !!(page.registration && page.registration.ignoreSellerPhone);
        },
        facebook({ page }) {
            return page.facebook;
        },
        google({ page }) {
            return page.google;
        },
        phoneDesciption({ page }) {
            return page.phoneDesciption || '';
        },
        toastMsg({ page }) {
            return (
                page.registration?.toast || this.$t('common:register.toastMsg')
            );
        },
        role({ page }) {
            return page.registerUserType || 'BUYER';
        },
        toastDuration({ page }) {
            return (
                (page.registration && page.registration.toastDuration) || 1000
            );
        },
        inquiry() {
            let inquiry = true;
            if (this.role === 'BUYER' || this.role === 'BANDS') {
                inquiry = !!(
                    this.page.questionNaire && this.page.questionNaire.inquiry
                );
            } else if (this.role === 'SELLER') {
                inquiry = !!(
                    this.page.questionNaire &&
                    this.page.questionNaire.inquirySeller
                );
            } else {
                inquiry = false;
            }
            return inquiry;
        },
        hasLenderCheckBox() {
            return (
                (this.role === 'BUYER' || this.role === 'RENTAL') &&
                this.page.hasLenderCheckBox
            );
        },
        ignorPhone() {
            if (this.role === 'BUYER') {
                return this.ignoreBuyerPhone;
            } else {
                return this.ignoreSellerPhone;
            }
        }
    },
    methods: {
        onRegisterCallback(callback, isToast) {
            if (
                util.call(callback, null, this.user, this.inquiry) !== false &&
                isToast &&
                this.toastMsg
            ) {
                util.toast(this.toastMsg);
            }
            this.submitDisabled = false;
        },
        onSuccessCallback(callback) {
            if (
                util.call(callback, null, this.data, this.inquiry) !== false &&
                this.toastMsg
            ) {
                util.toast(this.toastMsg, this.toastDuration);
            }
            this.submitDisabled = false;
        },
        registerNext() {
            // The logic of the reference is supplemented and perfected 
            this.onSuccessCallback();
        },
        showQuestionnaire(options = {}) {
            const type = this.role === 'SELLER' ? 1 : 0;
            questionnaire.open({ options, type, globalData: this.page });
        },
        onregisterFail(msg) {
            this.registerErrorShow = true;
            this.registerErrorMsg = msg;
            const vm = this;
            const needSignIn =
                msg === 'The email has been registered, please sign in.';
            util.timeout({
                handler: () => {
                    this.registerErrorShow = false;
                    this.registerErrorMsg = '';
                    needSignIn &&
                        openLoginHideOtherPop(
                            vm.options,
                            this.step1Data.email || this.step1Data.account || ''
                        );
                },
                delay: 3000,
                unique: true
            });
        },
        formatData(data, formatFun) {
            data.phoneNumber = data.phoneNumber || data.phone || '';
            data.account = data.account || data.email || '';
            data.fullname = data.fullname || data.fullName || '';
            data.pageUrl = window.location.href;
            // listingId and isSoldListing  rear end GlobalData Give 
            if (this.page.listingId !== undefined) {
                data.listingId = this.page.listingId;
            }
            if (this.page.isSoldListing !== undefined) {
                data.sold = this.page.isSoldListing;
            }
            let mName = data.fullname.match(/([\S]+)(?: +([\S\s]+))?/) || [
                null,
                ''
            ];
            data.firstName = data.firstName || mName[1] || '';
            data.lastName = data.lastName || mName[2] || '';
            if (!data.fullname) {
                if (data.prefix) {
                    data.firstName = data.prefix + ' ' + data.firstName;
                    delete data.prefix;
                }
                if (data.suffix) {
                    data.lastName = data.lastName + ' ' + data.suffix;
                    delete data.suffix;
                }
                data.fullname = data.firstName + ' ' + data.lastName;
            }

            data.role = this.role;
            data.phoneNumber = unformats.number(data.phoneNumber || '');

            data.canAssignToLender = this.role === 'BUYER' ? true : false;
            let campaignId = util.getQueryField('campaignId');
            if (campaignId) {
                data.campaignId = campaignId;
            }
            util.call(formatFun, null, data);
            this.data = data;
        },
        // https://jira.chimeinc.com/browse/SITE-12187
        // sell my house  page AddHouseInfo  and  register  The interface is merged into  /api-site/sell/add-house
        //  The registration interface in other places remains unchanged 
        // isAuto Flags automatically registered for background timing 
        submitRegisterInfo(virtualHouseInfo, isAuto) {
            virtualHouseInfo =
                virtualHouseInfo || (this.options && this.options.addHouseInfo); //  need to merge 
            if (virtualHouseInfo && !isAuto) {
                let tagIds = this.data.tag || virtualHouseInfo.tagIds || '';
                this.data.tagIds = tagIds;
                virtualHouseInfo.tagIds = tagIds;
                delete this.data.tag;
                return axios.post('/api-site/sell/add-house', {
                    registerInfo: this.data,
                    virtualHouseInfo
                });
            } else {
                let tag = this.data.tag;
                tag && (this.data.tagIds = tag);
                delete this.data.tag;
                let url = isAuto
                    ? '/api-site/auto/leadRegister'
                    : '/api-site/leadRegister';
                let data = this.data;
                if (this.options && this.options.questionFormat) {
                    data.question = this.options.questionFormat(data.question);
                }

                return axios.post(url, data);
            }
        },
        //  add one option parameter 
        // https://jira.chimeinc.com/browse/SITE-12187
        // md-sell-form middle pass option:{virtualHouseInfo:{}}
        //  used to judge   Do you need to  addHouseInfo  and register interface merge 
        leadRegister(option, isAuto = false) {
            return this.submitRegisterInfo(
                option && option.virtualHouseInfo,
                isAuto
            )
                .then(res => {
                    if (isAuto) return res;
                    const resData = res.data;
                    const user = resData.user;
                    if (resData.leadAccid && resData.leadToken) {
                        user.leadAccid = resData.leadAccid;
                        user.leadToken = resData.leadToken;
                    }
                    //  Advertising registration do not play questionnaire 
                    !this.data?.dynamicRegister &&
                        this.inquiry &&
                        questionnaire.prepare(undefined, this.page);
                    this.$store.commit(LOGIN, { user });
                    this.$EventBus.$emit('siteTrack', {
                        ...this.data,
                        trackType: 'register',
                        ele: this.$el
                    });
                    if (this.page.wordPressSSR && resData['0']) {
                        this.setCookies(resData['0']);
                    }
                    this.$store.commit(
                        UPDATE_SOCIAL_TAG_TYPE,
                        loginOrRegister.register
                    );
                    //  pass socialstudio users who click in ， Requires marking when logging in 
                    // setLeadTag(
                    //     loginOrRegister.register,
                    //     user?.id || '',
                    //     user?.teamId || ''
                    // );
                    // this.submitDisabled = false;
                    this.registerNext(this.data);
                    this.trackGlobalRegisPopup(regState.success);
                })
                .catch(error => {
                    console.error(error);
                    if (isAuto) {
                        return;
                    }
                    this.$EventBus.$emit('siteTrack', {
                        role: this.role,
                        errorData: error,
                        trackType: 'lead-register-fail',
                        ele: this.$el
                    });
                    if (!error.error) {
                        const errorMsg =
                            error.errorInfo ||
                            this.$t('common:register.registerError');
                        this.onregisterFail(errorMsg);
                    } else {
                        const errorMsg =
                            (error.errorInfo &&
                                error.errorInfo.status &&
                                error.errorInfo.status.msg) ||
                            this.$t('common:register.registerError');
                        this.onregisterFail(errorMsg);
                    }
                    this.trackGlobalRegisPopup(regState.fail);
                    // this.submitDisabled = false;
                });
        },
        setCookies(cookies) {
            console.warn('set cookies');
            for (let key in cookies) {
                console.log('set' + key + '=' + cookies[key]);
                util.setCookie(key, cookies[key], 30);
            }
        },
        //  automatic registration 
        leadAutoRegister(data, option) {
            this.formatData(data);
            this.submitRegisterInfo(option && option.virtualHouseInfo, true);
        },
        registerSubmit(form, data) {
            this.$EventBus.$emit('siteTrack', {
                ...data,
                role: this.role,
                trackType: 'lead-register-submit',
                ele: this.$el
            });
        },
        registerSubmitSuccess(data = {}) {
            if (this.submitDisabled) return;
            this.submitDisabled = true;
            this.formatData(data);
            return this.leadRegister();
        },
        registerSumbitError(errorInfo) {
            this.$EventBus.$emit('siteTrack', {
                errorInfo,
                role: this.role,
                trackType: 'lead-register-submit-fail',
                ele: this.$el
            });
            this.trackGlobalRegisPopup(regState.fail);
        },
        trackGlobalRegisPopup(state) {
            this.onTrack && this.onTrack(this.regType.register, state);
        }
    },
    components: {
        'v-form': vForm,
        'v-input': vInput
    }
};
